import { render, staticRenderFns } from "./SubEmpresaBlocoResumoContratoOriginacao.vue?vue&type=template&id=53999cf0&lang=pug"
import script from "./SubEmpresaBlocoResumoContratoOriginacao.vue?vue&type=script&lang=js"
export * from "./SubEmpresaBlocoResumoContratoOriginacao.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaBlocoResumoContratoOriginacao.vue?vue&type=style&index=0&id=53999cf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports